/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_View_File_MissingInputs */

const en_doc_view_file_missing = /** @type {(inputs: Doc_View_File_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document's file is no longer available. Upload it again if you still have it.`)
};

const pt_br2_doc_view_file_missing = /** @type {(inputs: Doc_View_File_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O arquivo deste documento não está mais disponível. Envie-o novamente, se ainda o tiver.`)
};

/**
* | output |
* | --- |
* | "This document's file is no longer available. Upload it again if you still have it." |
*
* @param {Doc_View_File_MissingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_view_file_missing = /** @type {((inputs?: Doc_View_File_MissingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_View_File_MissingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_view_file_missing(inputs)
	return pt_br2_doc_view_file_missing(inputs)
});